import { DatePipe } from '@angular/common';

export abstract class AbstractConfigurableDatePipe {

    private datePipe: DatePipe;

    constructor(locale: string) {
        this.datePipe = new DatePipe(locale);
    }
    
    transform(value: any, timezone?: string, locale?: string): string | null {
        return this.datePipe.transform(value, this.getFormat(), timezone, locale);
    }

    protected abstract getFormat(): string;
}


// WEBPACK FOOTER //
// ./src/app/utilities/AbstractConfigurableDatePipe.ts